const docViewTabBarTactics = {
  basic: {
    ModelTree: [],
    'system.Pickup': [],
    'system.Move': [
      'system.walk.fixView',
      'system.walk.first',
      'system.Rotate',
      'system.ToolFixedObservation',
      'system.Scale',
      'system.PickupCenter',
    ],
    'system.Rotate': [
      'system.Move',
      'system.walk.fixView',
      'system.walk.first',
      'system.ToolFixedObservation',
      'system.Scale',
      'system.PickupCenter',
    ],
    'system.ToolFixedObservation': [
      'system.Move',
      'system.walk.fixView',
      'system.walk.first',
      'system.Rotate',
      'system.Scale',
      'system.PickupCenter',
    ],
    'system.Scale': [
      'system.Move',
      'system.walk.fixView',
      'system.walk.first',
      'system.Rotate',
      'system.ToolFixedObservation',
      'system.PickupCenter',
    ],
    'system.PickupCenter': [
      'system.Scale',
      'system.Move',
      'system.walk.fixView',
      'system.walk.first',
      'system.Rotate',
      'system.ToolFixedObservation',
      'M_Line',
      'M_Point',
      'M_Vertical',
      'M_Angel',
      'M_Stereo',
      'M_Area',
      'M_WheelBase',
      'system.Pickup',
      'M_None',
    ],
    'system.ToolShowModel': [],
    'system.ToolHideModel': [],
    'system.ToolShowAll': [],
    'system.ToolHideModelSpaceSwap': [],
    smallMap: [],
    AllClip: ['PartClipBox', 'ThreePanel', 'UndergroundClip'],
    PartClipBox: ['AllClip', 'ThreePanel', 'UndergroundClip'],
    ThreePanel: ['AllClip', 'PartClipBox', 'UndergroundClip'],
    UndergroundClip: ['AllClip', 'PartClipBox', 'ThreePanel'],
    'system.walk.first': [
      'system.Move',
      'system.walk.fixView',
      'system.Rotate',
      'system.ToolFixedObservation',
      'system.Scale',
      'system.PickupCenter',
    ],
    'system.walk.fixView': [
      'system.Move',
      'system.walk.first',
      'system.Rotate',
      'system.ToolFixedObservation',
      'system.Scale',
      'system.PickupCenter',
    ],
    M_Line: [
      'system.PickupCenter',
      'M_Point',
      'M_Vertical',
      'M_Angel',
      'M_Stereo',
      'M_Area',
      'M_WheelBase',
      'M_None',
      'system.Pickup',
    ],
    M_Point: [
      'system.PickupCenter',
      'M_Line',
      'M_Vertical',
      'M_Angel',
      'M_Stereo',
      'M_Area',
      'M_WheelBase',
      'M_None',
      'system.Pickup',
    ],
    M_Vertical: [
      'system.PickupCenter',
      'M_Line',
      'M_Point',
      'M_Angel',
      'M_Stereo',
      'M_Area',
      'M_WheelBase',
      'M_None',
      'system.Pickup',
    ],
    M_Angel: [
      'system.PickupCenter',
      'M_Line',
      'M_Point',
      'M_Vertical',
      'M_Stereo',
      'M_Area',
      'M_WheelBase',
      'M_None',
      'system.Pickup',
    ],
    M_Stereo: [
      'system.PickupCenter',
      'M_Line',
      'M_Point',
      'M_Vertical',
      'M_Angel',
      'M_Area',
      'M_WheelBase',
      'M_None',
      'system.Pickup',
    ],
    M_Area: [
      'system.PickupCenter',
      'M_Line',
      'M_Point',
      'M_Vertical',
      'M_Angel',
      'M_Stereo',
      'M_WheelBase',
      'M_None',
      'system.Pickup',
    ],
    M_WheelBase: [
      'system.PickupCenter',
      'M_Line',
      'M_Point',
      'M_Vertical',
      'M_Angel',
      'M_Stereo',
      'M_Area',
      'M_None',
      'system.Pickup',
    ],
    M_None: [
      'system.PickupCenter',
      'M_Line',
      'M_Point',
      'M_Vertical',
      'M_Angel',
      'M_Stereo',
      'M_Area',
      'M_WheelBase',
      'system.Pickup',
    ],
    EditTexture: [],
    transparencySetting: [],
  },
  business: {
    CableList: ['MeasurePoint'],
    clashList: ['MeasurePoint', 'ProcessRelational'],
    ProcessRelational: ['clashList'],
    RoamPathList: [],
    PointSetting: [],
    MonitorList: [],
    MeasurePoint: ['CableList', 'clashList'],
    EquipmentInfo: ['AlarmInfo'],
    AlarmInfo: ['EquipmentInfo'],
    xslx: ['gblx', 'qbxs', 'qbgb', 'gllx'],
    gblx: ['xslx', 'qbxs', 'qbgb', 'gllx'],
    qbxs: ['gblx', 'xslx', 'qbgb', 'gllx'],
    qbgb: ['gblx', 'qbxs', 'xslx', 'gllx'],
    gllx: ['gblx', 'qbxs', 'qbgb', 'xslx'],
  },
  notDisplayByOpenGis: ['smallMap', 'system.walk.first', 'system.walk.fixView', 'RoamPathList'],
}

export default docViewTabBarTactics
